import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M12.574 2.5c0 .487-.126.975-.25 1.462-.133.513-.264 1.025-.25 1.538.012.461.301 1.112.695 1.792 1.202 2.076 1.61 4.599.536 6.745l-.731 1.463h-4l-.719-1.437c-1.08-2.159-.654-4.696.551-6.788.388-.673.668-1.317.668-1.775 0-.505-.128-1.018-.254-1.527-.123-.5-.246-.995-.246-1.473a2 2 0 0 1 4 0Zm-9.387.6c0-.884.685-1.6 1.53-1.6.846 0 1.531.716 1.532 1.6 0 .39-.095.78-.191 1.17-.101.41-.202.82-.191 1.23.011.423.3 1.045.67 1.673.041.072.082.144.122.218-.86 1.855-1.23 4.031-.628 6.11H3.187l-.678-1.418c-.754-1.576-.472-3.415.413-4.921.366-.625.648-1.242.648-1.662 0-.404-.097-.815-.194-1.222-.095-.4-.189-.796-.189-1.178Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconInfrastructureBowling16 = createIcon(IconComponent);